// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__6nJ3b","info":"Note_info__1oLAs","note":"Note_note__1jwl9","actions":"Note_actions__2baR-"};